import { Grid, Paper, Typography, Button } from '@mui/material';

export default function ServiceBox(props) {
  const IconComponent = props.icon;
  return (
    <Paper
      sx={{ backgroundColor: '#00529b', width: 250, padding: 1, margin: 2 }}
    >
      <Grid
        container
        direction='column'
        justifyContent='center'
        alignItems='center'
      >
        <IconComponent
          sx={{
            fontSize: 40,
            color: '#FFFFFF',
          }}
        />
        <Typography sx={{ color: '#FFFFFF', fontWeight: 'bold' }}>
          {props.label}
        </Typography>
        <Typography sx={{ color: '#FFFFFF' }}>{props.data}</Typography>
        {props.link && (
          <Button
            variant='contained'
            href={props.link}
            target='_blank'
            color='white'
          >
            {props.buttonLabel ? props.buttonLabel : 'More Info'}
          </Button>
        )}
      </Grid>
    </Paper>
  );
}
